var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[(['12', '8'].includes(_vm.fiberCount) && _vm.plugSideACount === 1)?_c('simplex-cable',_vm._b({attrs:{"is-pigtail":true}},'simplex-cable',Object.assign({}, _vm.$props, {cableColor: _vm.remainingWhipsA.length === 1 ? _vm.remainingWhipsA[0].color : 'default'}),false)):_vm._e(),(['12', '8'].includes(_vm.fiberCount) && _vm.plugSideBCount === 1)?_c('simplex-cable',_vm._b({attrs:{"transform":`translate(${_vm.svgWidth} 0) scale(-1 1)`,"is-pigtail":true}},'simplex-cable',Object.assign({}, _vm.$props, {cableColor: _vm.remainingWhipsB.length === 1 ? _vm.remainingWhipsB[0].color : 'default'}),false)):_vm._e(),_c(_vm.cableType,_vm._b({tag:"component"},'component',Object.assign(
    _vm.$props, 
    { 
      whipColor: 
        _vm.remainingWhipsA.length === 1 
          ? _vm.remainingWhipsA[0].color 
          : 'default'
    }),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }